import React from 'react'
import Box from '@mui/material/Box'
import SvgIcon, { SvgIconProps } from '@mui/material/SvgIcon'
import PeopleOutlined from '@mui/icons-material/PeopleOutlined'
import FolderData from './FolderData'

// Material Symbols "arrow_range" (outlined); not shipped by @mui/icons-material,
// so the path is inlined from google/material-design-icons.
const ArrowRange = (props: SvgIconProps) => (
  <SvgIcon {...props} viewBox="0 -960 960 960">
    <path d="M280-280 80-480l200-200 56 56-103 104h494L624-624l56-56 200 200-200 200-56-56 103-104H233l103 104-56 56Z" />
  </SvgIcon>
)

// Users <-> folders, for the member report button.
const MemberReportIcon = ({ className }: { className?: string }) => (
  <Box
    component="span"
    className={className}
    sx={{ display: 'inline-flex', alignItems: 'center', gap: 0.25, pl: 1 }}
  >
    <PeopleOutlined fontSize="small" />
    <ArrowRange fontSize="small" />
    <FolderData fontSize="small" />
  </Box>
)

export default MemberReportIcon
